import { useContext } from "react";
import SingleCustomerContext from "../../Customer-Context/SingleCustomerContext";
import { Box, Flex, Group, HoverCard, Stack, Text, Tooltip } from "@mantine/core";
import { isBagelAdminOrManager, stripHtml } from "../../../../utils";
import { DARK_GREY_TEXT, LIGHT_BLUE_BACKGROUND, LIGHT_GREY_BG, MAIN_DARK_PRIMARY } from "../../../../constants/colors";
import { IconArrowRight, IconX } from "@tabler/icons";
import SyncContext from "../../../../context/SyncContext";
import { useAuth0 } from "@auth0/auth0-react";
import { SourceIcon } from "../../../../utils/SourceIcon";

const IdeaDetails = () => {

  const { displayState } = useContext(SyncContext);

  const { chosenIdea, setCardOpened, setChosenEvidence, setActivityOpened } = useContext(SingleCustomerContext);

  const auth0 = useAuth0()

  const isAdminOrManger = isBagelAdminOrManager(auth0.user)



  const togglePanel = () => {

    setCardOpened((prev: boolean) => !prev);
    setChosenEvidence(null)
    setActivityOpened(false)
  };

  const idea = chosenIdea
  const title = idea?.title
  const description = idea?.description
  const productArea = idea?.componentObj?.name
  const domain = idea?.componentObj?.domain
  const status = idea?.status || 'Unassigned'
  const productItem = idea?.linkedProductItem

  return (
    <Box py={20}
      px={36}
      h={120} 
      sx={{borderBottom: '1px solid #E9ECEF'}}
      bg={LIGHT_GREY_BG}>
      <Flex justify='space-between' align='center'>
        <Text fz={10} color={DARK_GREY_TEXT}>
          IDEA DETAILS
        </Text>
        <Flex>
          <Flex
            w={95}
            h={24}
            bg={LIGHT_BLUE_BACKGROUND}
            sx={{ borderRadius: 4, cursor: "pointer" }}
            onClick={() =>
              window.open(`/idea/${chosenIdea?._id}`, "_blank")
            }
            px={8}
            py={4}
            align="center"
            justify="space-between"
            mb={12}
            mr={8}
          >
            <IconArrowRight size={14} />
            <Text fz={12} ta="center">
                  Go to idea
            </Text>
          </Flex>
          <Box
            sx={{ cursor: "pointer" }}
            onClick={togglePanel}
          >
            <IconX size={14} color="#5C5CEB" />
          </Box>
        </Flex>
        
        
      </Flex>
      <Flex 
        
        justify='space-between'
      >
        <HoverCard>
          <HoverCard.Target>
            <Box w={305}>
        
              <Text
                w={305}
                maw={305}
                lineClamp={1}
                fz={18}
                fw={600}
                color={MAIN_DARK_PRIMARY}
              >
                {title}
              </Text>
              <Text
                color='#585c68'
                fz={14}
                lineClamp={1}
              >
                {stripHtml(description)}
              </Text>
            </Box>
          </HoverCard.Target>
          <HoverCard.Dropdown sx={{boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}>
            <Box w={345}>
              <Text
                w={345}
                maw={345}
                mb={2}
                fz={14}
                fw={600}
                color={MAIN_DARK_PRIMARY}
              >
                {title}
              </Text>
              <Text
                size="sm"
                sx={{
                  whiteSpace: 'pre-wrap',
                  maxHeight: 100,
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical',
                  textOverflow: 'ellipsis'
                }}
              >
                {stripHtml(description)}
              </Text>
            </Box>
          </HoverCard.Dropdown>
        </HoverCard>
      
        <Flex>
          {displayState?.status &&
          
          
          <Flex>
            <Box>
          

              <Flex>
                <Text fz={12} mb={4} color={DARK_GREY_TEXT}>Status</Text>
                {productItem && 
                  <Group
                    noWrap
                    spacing={6}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#F8F8FB",
                        borderRadius: "4px",
                      },
                      padding: "2px 4px",
                    }}
                  >
                    <Tooltip withArrow disabled={!productItem?.itemKey} label={`Click to open ${productItem?.itemKey}`}>
                      <Stack align="center" justify="center" mb={3.6} sx={{cursor:'pointer'}}>
                        <SourceIcon sourceName={productItem?.origin} width={12} height={12} />
                      </Stack>
                    </Tooltip>
                    
                    

                    {/* <Text
                      component="a"
                      href={productItem?.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      lineClamp={1}
                      size={"sm"}
                      color="indigo"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {productItem?.itemKey}
                    </Text> */}
                  </Group>
                }
              </Flex>
              
              <Tooltip
                label={status}
                multiline
              >
                <Text
                  lineClamp={1}
                  fz={12}
                  p={4}
                  sx={{
                    borderRadius: 6,
                  }}
                  bg={LIGHT_BLUE_BACKGROUND}
                >
                  {status}

                </Text>
              </Tooltip>
            </Box>
          </Flex>
          }

          {displayState?.domain && <Box ml={7}>
         
            <Text fz={12} mb={4} color={DARK_GREY_TEXT}>Domain</Text>
            <Tooltip
              label={domain}
              multiline
            >
              <Text
                lineClamp={1}
                fz={12}
                p={4}
                sx={{
                  borderRadius: 6,
                }}
                bg={LIGHT_BLUE_BACKGROUND}
              >
                {domain}

              </Text>
            </Tooltip>
          </Box>}

          {displayState.component && <Box ml={7}>
            <Tooltip
              label='Product Area'
              multiline
              maw={176} 
              position="top"
            >
              <Text lineClamp={1} 
                fz={12} 
                mb={4} 
                color={DARK_GREY_TEXT}>
              Product Area
              </Text>
            </Tooltip>
            <Tooltip
              label={productArea}
              multiline
              maw={176} 
              position="top"
            >
              <Text
                lineClamp={1}
                fz={12}
                bg={LIGHT_BLUE_BACKGROUND}
                sx={{
                  borderRadius: 6,
                  padding: 4,
                }}
                maw={176}
              >
                {productArea}

              </Text>
            </Tooltip>
          </Box>}
          
        </Flex>
      </Flex>
    </Box>
    
  )
}

export default IdeaDetails